import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Controller } from 'react-hook-form';
import { useTheme } from '@mui/material/styles';
import { Box, Typography, Grid, Button } from '@mui/material';
import InventoryHostModal from './InventoryHostModal';
import {Alert, TableCustom} from 'components/common';
import SpeakerNotesOffIcon from '@mui/icons-material/SpeakerNotesOff';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';


const InventoryHost = ({
  methods,
  policies,
  items,
  soloVer
}) => {
  const [t] = useTranslation();
  const { getValues, setValue, control} = methods;
  const [openModal, setOpenModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [indexHostEdit, setIndexHostEdit] = useState(null);
  const [showAlert, setshowAlert] = useState(false);
  const [defaultValues, setDefaultValues] = useState({
    modalHostName: '',
    modalIpAddress: '',
    modalNetworkType: '',
    modalTags: [],
    modalIsActive: false,
    modalVariables: '',
    language: 'ini',
  });
  const theme = useTheme();


  const onSubmitCreate = (data) => {
    const hosts = [...getValues(policies.hosts.name), data];
    setValue(policies.hosts.name, hosts);
    handleCloseModal();
  };

  const onSubmitEdit = (data) => {
    const hosts = getValues(policies.hosts.name).map((h,i) => {
      if (i === data.index) {
        return {
          name: data.name,
          ip: data.ip,
          tags: data.tags,
          networkType: data.networkType,
          isActive: data.isActive,
          variables: data.variables,
          variablesType: data.variablesType
        }
      } else return h
    });
    setValue(policies.hosts.name, hosts);
    handleCloseModal();
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleAdd = (data) => {
    setDefaultValues({
      modalHostName: '',
      modalIpAddress: '',
      modalNetworkType: '',
      modalTags: [],
      modalIsActive: false,
      modalVariables: '',
      language: 'json',
    });
    setIsEdit(false);
    setOpenModal(true);
  };

  const handleDelete = (item) => {
    const groups = getValues(policies.hostGroups.name);
    const groupsThatUseHost = groups.map(g => {
      const hostFound = g.hosts.map(h => item.name === h.name && item.ip === h.ip);
      return (hostFound) ? 'yes' : 'no';
    })
    if (groupsThatUseHost.includes('yes')) {
      setshowAlert(true);
    } else {
      const items = getValues(policies.hosts.name);
      setValue(
       policies.hosts.name,
         items.filter(i => `${i.name}-${i.ip}` !== `${item.name}-${item.ip}`)
      );
    }
  };

  const handleEdit = (item) => {
    setDefaultValues({
      modalHostName: item.name,
      modalIpAddress: item.ip,
      modalNetworkType:item.networkType,
      modalTags:item.tags,
      modalIsActive:item.isActive,
      modalVariables:item.variables,
      language: item.variablesType
    });


    const items = getValues(policies.hosts.name);
    const indexHost = items.findIndex(h => h.name === item.name && h.ip === item.ip);
    setIndexHostEdit(indexHost);
    setIsEdit(true);
    setOpenModal(true);
  };

  const columns = [
    { label: t('inventoryList.hosts.table.columns.name'), key: 'name' },
    { label: t('inventoryList.hosts.table.columns.ip'), key: 'ip' },
  ];

  const actions = [
    {
      label: t('inventoryList.hosts.table.actions.edit'),
      icon: <EditOutlinedIcon color='primary'/>,
      handle: handleEdit
    },
    {
      label: t('inventoryList.hosts.table.actions.delete'),
      icon: <HighlightOffIcon color='primary'/>,
      handle: handleDelete
    }
  ];

  const handleCloseAlert = () => {
    setshowAlert(false);
  }

  return (
    <>
      <Box sx={{ overflow: 'hidden' }}>
        <Grid container spacing={2} alignItems="center" sx={{ pt: 1 }}>
          <Grid item xs={12} sm={4} md={4} lg={4} sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: 3
          }}>
            <Typography variant="h6" sx={{ padding: '4px 0px' }}>
              {t('inventoryList.hosts.title')}
            </Typography>
            {!soloVer?<Button variant="contained" onClick={handleAdd} type="button">
              {t('inventoryList.hosts.button')}
            </Button>:null}
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Box
              sx={{
                border: `1px solid ${theme.palette.grey[400]}`,
                borderRadius: 1,
                overflow: 'hidden',
              }}
            >
              <Controller
                control={control}
                name={policies.hosts.name}
                id={policies.hosts.id}
                render={({ field: { value } }) => (
                  <TableCustom
                    columns={columns}
                    content={value}
                    actions={actions}
                    config={{
                      notResults: {
                        title: 'inventoryList.hosts.table.title',
                        description: 'inventoryList.hosts.table.description',
                        disabledIcon: true,
                        size: '20vh'
                      }
                    }}
                  />
                )}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
      { openModal &&
        <InventoryHostModal
          open={openModal}
          handleClose={handleCloseModal}
          onSubmitCreate={onSubmitCreate}
          onSubmitEdit={onSubmitEdit}
          defaultValues={defaultValues}
          isEdit={isEdit}
          policies={policies}
          items={getValues(policies.hosts.name)}
          index={indexHostEdit}
        />
      }
      <Alert severity="error"
             handleClose={handleCloseAlert}
             open={showAlert}
             message="inventoryList.hosts.error.hostDelete"
      />
    </>
  );
};


export default InventoryHost;
